export default __webpack_public_path__ + "static/tessa-5ee59bcb485450a8f35336f5c1274f6e.jpg";